import { createSelector } from '@reduxjs/toolkit';

import { InsightsState } from 'app-redux/InsightsState';
import { parseIsoDateStartOfDayUtc0 } from 'utils/dateTimeHelpers';

import { SparklineDatumType } from 'components/_graphs/_common/DiseaseActivityModels';

const getGraphDataProximal = (diseaseId: number) =>
  createSelector(
    (state: InsightsState) => state.diseaseActivitiesTemporal.isLoadingTemporalByDiseaseId,
    (state: InsightsState) => state.diseaseActivitiesTemporal.temporalByDiseaseId[diseaseId],
    (isLoadingTemporal, temporalData) =>
      isLoadingTemporal
        ? null
        : (temporalData || []).map(
            x =>
              ({
                date: parseIsoDateStartOfDayUtc0(x.startDate),
                cases: x.countryCaseCounts?.reportedCases ?? 0,
                nearby: x.caseCounts?.reportedCases ?? 0,
              } as SparklineDatumType)
          )
  );
const getGraphDataGlobal = (diseaseId: number) =>
  createSelector(
    (state: InsightsState) => state.diseaseActivitiesTemporal.temporalByDiseaseId[diseaseId],
    temporalByDiseaseId =>
      (temporalByDiseaseId || []).map(
        x =>
          ({
            date: parseIsoDateStartOfDayUtc0(x.startDate),
            cases: x.caseCounts?.reportedCases || 0,
          } as SparklineDatumType)
      )
  );

const getGraphDataForCountry = (diseaseId: number) =>
  createSelector(
    (state: InsightsState) => state.diseaseActivitiesTemporal.isLoadingTemporalByCountryId,
    (state: InsightsState) => state.diseaseActivitiesTemporal.temporalByCountryId[diseaseId],
    (isLoadingTemporal, temporalData) =>
      isLoadingTemporal
        ? null
        : (temporalData || []).map(
            x =>
              ({
                date: parseIsoDateStartOfDayUtc0(x.startDate),
                cases: x.caseCounts?.reportedCases ?? 0,
              } as SparklineDatumType)
          )
  );

// diseaseActivitiesTemporalSelectors
export default {
  getGraphDataProximal,
  getGraphDataGlobal,
  getGraphDataForCountry,
};
